import React from 'react';
import { Stack, Text, ThemeIcon } from '@mantine/core';
import { IconCalendarPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { User } from '../../utils/session';
import { Account } from '../AccountCard';
import { AddCalendarAccountWrapper } from '../AddCalendarAccount';

export const OnboardingConnectAccount: React.FC<{
    user: User;
    accounts: Account[];
    updateAccounts: () => void;
    hideHeader?: boolean;
}> = ({ user, accounts, updateAccounts, hideHeader = false }) => {
    const { t } = useTranslation(['app']);

    return (
        <Stack gap="lg">
            {!hideHeader && (
                <Stack gap="md" align="center">
                    <ThemeIcon size={64} radius="xl" variant="light" color="brand">
                        <IconCalendarPlus size={32} />
                    </ThemeIcon>
                    <Stack gap="xs" align="center">
                        <Text size="xl" fw={700} ta="center">{t('dashboard.onboarding.step1.title')}</Text>
                        <Text c="dimmed" ta="center" maw={480}>{t('dashboard.onboarding.step1.description')}</Text>
                    </Stack>
                </Stack>
            )}
            <AddCalendarAccountWrapper user={user} accounts={accounts} updateAccounts={updateAccounts} />
        </Stack>
    );
};
